import {BRAND} from "../app/core/constants";

export const environment = {
    appVersion: require('../../package.json').version,
    production: true,
    hmr: false,
    local: false,
    app: false,
    http_params: {
        authUsername: 'vpq5e86nlvnl',
        authPassword: 'u7nelm1t0tla93leqcguiat9',
        baseUrl: 'https://stage.yourmechanic.com',
        defaultConfig: {timeout: 30000}
    },
    angulartics: false,
    ymRedirect: false,
    ws_endpoint:  "wss://fr1r9k3v5a.execute-api.us-west-2.amazonaws.com/dev",
    brand: BRAND.YM
};
